module.exports = __webpack_public_path__ + "static/media/069.177867ff.jpg";